import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import i18n from '../assets/lang'
import * as types from '../store/types'
import api from '../api'

import DashView from '../Dash'

import Login from 'pages/login'

import ResetPassword from 'pages/on-boarding/reset-password'
import Agreement from 'pages/on-boarding/agreement'
import Contract from 'pages/on-boarding/contract'
import ServiceFee from 'pages/on-boarding/service-fee'

import Dashboard from 'pages/dashboard'

import Transactions from 'pages/transactions/transactions'
import TransactionDetail from 'pages/transactions/view-detail'

import Refunds from 'pages/refunds/refunds'
import RefundsDetail from 'pages/refunds/view-detail'

import Customers from 'pages/customers/customers'

// analytics folder
import AnalyticsTransactions from 'pages/analytics/transactions'
import AnalyticsCustomers from 'pages/analytics/customers'
import AnalyticsOutlets from 'pages/analytics/outlets'

import Accounts from 'pages/management/accounts/accounts'
import AddNewAccounts from 'pages/management/accounts/add-new-account'
import UpdateAccount from 'pages/management/accounts/update-account'

// outlets folder
import Outlets from 'pages/management/outlets/outlets'
import AddNewOutlet from 'pages/management/outlets/add-new-outlet'
import ViewOutletDetail from 'pages/management/outlets/view-detail'
import UpdateOutlet from 'pages/management/outlets/update-outlet'
import Invoices from 'pages/management/invoices/invoices'
import DownloadContract from 'pages/management/contract/contract'
import Settlements from 'pages/settlements/settlements'

// coupons folder
import CouponList from 'pages/coupons/coupon-list'
import ChooseCoupon from 'pages/coupons/choose-coupon'
import AddCoupon from 'pages/coupons/add-coupon'
import CouponAgreement from 'pages/coupons/agreement'
import CouponTips from 'pages/coupons/coupon-tips'
// settings folder
import SettingsPaymentChannels from 'pages/settings/payment-channels'
import SettingsBank from 'pages/settings/bank'
import SettingsPasswords from 'pages/settings/passwords'
import SettingsQRcodes from 'pages/settings/qrcodes'
import SettingsRefundPassword from 'pages/settings/refund-password'
// 404 401 500
import NotFound from 'pages/404'
import LimitAuth from 'pages/401'
import NoService from 'pages/500'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  routes: [

    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'login'
      },
      beforeEnter: (to, from, next) => {
        if (window.store.get('version-m') === '1.0' && window.store.get('MERCHANTLOGINED')) {
          // have session . go into dashboard page
          if (store.state.user.userinfo !== null && store.state.user.userinfo.onBoarding === '1') {
            next({
              path: '/on-boarding/resetPassword'
            })
          } else if (store.state.user.userinfo !== null && store.state.user.userinfo.onBoarding === '2') {
            next({
              path: '/on-boarding/agreement'
            })
          } else if (store.state.user.userinfo !== null && store.state.user.userinfo.onBoarding === '3') {
            next({
              path: '/on-boarding/service-fee'
            })
          } else {
            next({
              path: store.state.user.userinfo.pageIndex
            })
          }
        } else {
          // no session , go into login page
          next()
        }
      }
    }, {
      path: '/',
      redirect: '/login'
    }, {
      path: '/on-boarding/resetPassword',
      component: ResetPassword,
      name: 'OB-ResetPwd',
      meta: {
        title: 'onBoarding.reset'
      },
      beforeEnter: (to, from, next) => {
        // changePassword: true 的时候不能再次进入这个页面
        if (store.state.user.userinfo.onBoarding === '1') {
          next()
        } else {
          next({
            name: 'No-Right'
          })
        }
      }
    }, {
      path: '/on-boarding/agreement',
      component: Agreement,
      name: 'OB-Agreement',
      meta: {
        title: 'onBoarding.agreement'
      },
      beforeEnter: (to, from, next) => {
        // 未签约才能进入
        if (store.state.user.userinfo.onBoarding === '2') {
          next()
        } else {
          next({
            name: 'No-Right'
          })
        }
      }
    }, {
      path: '/on-boarding/contract',
      component: Contract,
      name: 'OB-Contract',
      meta: {
        title: 'onBoarding.contract'
      },
      beforeEnter: (to, from, next) => {
        // 未签约才能进入
        if (store.state.user.userinfo.onBoarding === '2') {
          next()
        } else {
          next({
            name: 'No-Right'
          })
        }
      }
    }, {
      path: '/on-boarding/service-fee',
      component: ServiceFee,
      name: 'OB-ServiceFee',
      meta: {
        title: 'onBoarding.serviceFee'
      },
      beforeEnter: (to, from, next) => {
        // 未签约才能进入
        if (store.state.user.userinfo.onBoarding === '3') {
          next()
        } else {
          next({
            name: 'No-Right'
          })
        }
      }
    }, {
      path: '/',
      component: DashView,
      beforeEnter: (to, from, next) => {
        // 已经修改并且已经签约
        if (store.state.user.userinfo !== null && store.state.user.userinfo.onBoarding === '4') {
          next()
        } else if (store.state.user.userinfo === null) {
          next({
            name: 'Login'
          })
        } else {
          next({
            name: 'Login'
          })
        }
      },
      children: [

        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            title: 'dashboard'
          }
        }, {
          path: '/trx',
          name: 'Transactions',
          component: Transactions,
          meta: {
            title: 'transactions.self'
          }
        }, {
          path: '/trx/view/:id',
          name: 'Transaction-Detail',
          component: TransactionDetail,
          meta: {
            title: 'transactions.view'
          }
        }, {
          path: '/refund',
          name: 'Refund',
          component: Refunds,
          meta: {
            title: 'refunds.self'
          }
        }, {
          path: '/refund/view/:id',
          name: 'Refund-Detail',
          component: RefundsDetail,
          meta: {
            title: 'refunds.view'
          }
        }, {
          path: '/customers',
          name: 'Customers',
          component: Customers,
          meta: {
            title: 'customers'
          }
        },
        {
          path: '/coupons',
          name: 'Coupon-List',
          component: CouponList,
          meta: {
            title: 'coupons.self'
          },
          beforeEnter: (to, from, next) => {
            checkCoupon(next, from)
          }
        },
        {
          path: '/choose-coupon',
          name: 'Choose-Coupon',
          component: ChooseCoupon,
          meta: {
            title: 'coupons.choose'
          },
          beforeEnter: (to, from, next) => {
            checkCoupon(next, from)
          }
        },
        {
          path: '/add-coupon',
          name: 'Add-Coupon',
          component: AddCoupon,
          meta: {
            title: 'coupons.add'
          },
          beforeEnter: (to, from, next) => {
            checkCoupon(next, from)
          }
        },
        {
          path: '/coupon-agreement',
          name: 'Coupon-Agreement',
          component: CouponAgreement,
          meta: {
            title: 'coupons.agreement'
          }
        },
        {
          path: '/coupon-tips',
          name: 'Coupon-Tips',
          component: CouponTips,
          meta: {
            title: 'coupons.tips'
          },
          beforeEnter: (to, from, next) => {
            if (from.name === null) {
              api.ckeckCouponStatus().then(res => {
                const result = res.data.data
                if (res.data.code === 200) {
                  if (result.allowCoupon && result.agreeCoupon) {
                    next({
                      name: 'Coupon-List'
                    })
                  } else if (!result.allowCoupon) {
                    next()
                  }
                }
              })
            } else {
              next()
            }
          }
        },
        {
          path: '/management/account',
          name: 'Accounts',
          component: Accounts,
          meta: {
            title: 'accounts.self'
          }
        }, {
          path: '/management/account/add-new-account',
          name: 'Add-New-Account',
          component: AddNewAccounts,
          meta: {
            title: 'accounts.add'
          }
        }, {
          path: '/management/account/update-account/:id',
          name: 'Update-Account',
          component: UpdateAccount,
          meta: {
            title: 'accounts.update'
          }
        }, {
          path: '/management/outlets',
          name: 'Outlets',
          component: Outlets,
          meta: {
            title: 'outlets.self'
          }
        }, {
          path: '/management/outlets/add-new-outlet',
          name: 'Add-New-Outlet',
          component: AddNewOutlet,
          meta: {
            title: 'outlets.add'
          }
        }, {
          path: '/management/outlets/view/:id',
          name: 'View-Outlet-Detail',
          component: ViewOutletDetail,
          meta: {
            title: 'outlets.view'
          }
        }, {
          path: '/management/outlets/update/:id',
          name: 'Update-Outlet',
          component: UpdateOutlet,
          meta: {
            title: 'outlets.update'
          }
        }, {
          path: '/management/invoices',
          name: 'Invoices',
          component: Invoices,
          meta: {
            title: 'invoices'
          }
        }, {
          path: '/settlements',
          name: 'Settlements',
          component: Settlements,
          meta: {
            title: 'settlements'
          }
        }, {
          path: '/management/contract',
          name: 'DownloadContract',
          component: DownloadContract,
          meta: {
            title: 'contract'
          }
        },
        {
          path: '/analytics/trx',
          name: 'Analytics-Transactions',
          component: AnalyticsTransactions,
          meta: {
            title: 'analytics.trx'
          }
        }, {
          path: '/analytics/customer',
          name: 'Analytics-Customers',
          component: AnalyticsCustomers,
          meta: {
            title: 'analytics.customers'
          }
        }, {
          path: '/analytics/outlet',
          name: 'Analytics-Outlets',
          component: AnalyticsOutlets,
          meta: {
            title: 'analytics.outlets'
          }
        },
        {
          path: '/settings/payment-channels',
          name: 'Settings-PaymentChannels',
          component: SettingsPaymentChannels,
          meta: {
            title: 'settings.payment'
          }
        },
        {
          path: '/settings/bank',
          component: SettingsBank,
          meta: {
            title: 'settings.bank'
          }
        }, {
          path: '/settings/qrcode',
          component: SettingsQRcodes,
          meta: {
            title: 'settings.qrcode'
          }
        }, {
          path: '/settings/password',
          component: SettingsPasswords,
          meta: {
            title: 'settings.pwd'
          }
        }, {
          path: '/settings/refund-password',
          component: SettingsRefundPassword,
          name: 'SettingsRefundPassword',
          meta: {
            title: 'settings.refundPwd'
          }
        }
      ]
    }, {
      path: '/404',
      component: NotFound,
      meta: {
        title: '404'
      }
    }, {
      path: '/401',
      component: LimitAuth,
      name: 'No-Right',
      meta: {
        title: '401'
      }
    }, {
      path: '/500',
      component: NoService,
      name: 'No-Service',
      meta: {
        title: '500'
      }
    }, {
      path: '*',
      redirect: '/404'
    }
  ],
  linkActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
  const pt = i18n.t(`pageTitle.${to.meta.title}`)
  document.title = pt + store.state.theme.companyInfo.baseTitle
  if (store.state.user.userinfo !== null) {
    Vue.$ga.set({
      userId: store.state.user.userinfo.id
    })
  }

  store.commit(types.NAVINFO, {
    navtitle: pt
  })
  next()
})

function checkCoupon(cb, from) {
  api.ckeckCouponStatus().then(res => {
    const result = res.data.data
    if (res.data.code === 200) {
      if (result.allowCoupon && result.agreeCoupon) {
        cb()
      } else if (!result.allowCoupon) {
        cb({
          name: 'Coupon-Tips',
          query: {
            email: result.email,
            number: result.contactNumber
          }
        })
      } else if (!result.agreeCoupon) {
        cb({
          name: 'Coupon-Agreement'
        })
      }
    }
  })
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js